import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-stakeholder-header",
  templateUrl: "./stakeholder-header.component.html",
  styleUrls: ["./stakeholder-header.component.scss"],
})
export class StakeholderHeaderComponent implements OnInit {
  env: any = environment;
  @Output() refreshClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  onRefreshClicked() {
    this.refreshClicked.emit();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/stakeholder-header/stakeholder-header.component.ts